import { apiClient } from "@/api/client";
import type { ListQuery, Paginated } from "@/types/common";
import type { KycApplication, KycStatus } from "@/types/domain";

/** Talks to apps/kyc-service admin routes directly (gateway routes /kyc(/|$) -> kyc-service). */
export const kycApi = {
  /** GET /kyc/admin/applications — defaults to IN_REVIEW (open queue awaiting review) when status is omitted. */
  list: (query: ListQuery & { status?: KycStatus }) =>
    apiClient
      .get<Paginated<KycApplication>>("/kyc/admin/applications", { params: query })
      .then((r) => r.data),

  /** GET /kyc/admin/applications/:id */
  getById: (id: string) =>
    apiClient.get<KycApplication>(`/kyc/admin/applications/${id}`).then((r) => r.data),

  /** PATCH /kyc/admin/applications/:id/approve — body: { notes? }. */
  approve: (id: string, notes?: string) =>
    apiClient
      .patch<KycApplication>(`/kyc/admin/applications/${id}/approve`, { notes })
      .then((r) => r.data),

  /** PATCH /kyc/admin/applications/:id/reject — body: { reason } (required, 3-300 chars). */
  reject: (id: string, reason: string) =>
    apiClient
      .patch<KycApplication>(`/kyc/admin/applications/${id}/reject`, { reason })
      .then((r) => r.data),

  /** GET /kyc/documents/:documentId/url — short-lived (5 min) presigned S3 view URL. */
  getDocumentUrl: (documentId: string) =>
    apiClient
      .get<{ url: string; expiresInSeconds: number; contentType: string }>(
        `/kyc/documents/${documentId}/url`,
      )
      .then((r) => r.data),
};
